import { Route } from "src/types";
import {
  Accessibility,
  CheckoutResult,
  CookiePolicy,
  Error404,
  Faqs,
  Landing,
  ReturnCheckout,
} from "src/ui/pages";
import { DataEntryWrapper } from "src/ui/pages/data-entry/data-entry.wrapper";

export const Paths: Record<string, string> = {
  LandingId: "/:id",
  Landing: "/",
  Faqs: "/faqs",
  CookiePolicy: "/cookie-policy",
  Accessibility: "/accessibilita",
  DataEntry1: "/inserimento-dati-step-1",
  DataEntry2: "/inserimento-dati-step-2",
  DataEntry3: "/inserimento-dati-step-3",
  DataEntry4: "/inserimento-dati-step-4",
  DataEntry5: "/inserimento-dati-step-5",
  EntryGroup2: "/inserimento-dati-gruppo-step-2",
  EntryGroup3: "/inserimento-dati-gruppo-step-3",
  EntryGroup4: "/inserimento-dati-gruppo-step-4",
  EntryGroup5: "/inserimento-dati-gruppo-step-5",
  EntryGroup6: "/inserimento-dati-gruppo-step-6",
  ReturnCheckout: "/esito-pagamento",
  CheckoutResult: "/esito-pagamento-risultato",
  Error404: "*",
};

export const NotLandingPaths: string[] = [
  Paths.Faqs,
  Paths.CookiePolicy,
  Paths.Error404,
  Paths.Accessibility,
  Paths.DataEntry1,
  Paths.DataEntry2,
  Paths.DataEntry3,
  Paths.DataEntry4,
  Paths.DataEntry5,
  Paths.EntryGroup2,
  Paths.EntryGroup3,
  Paths.EntryGroup4,
  Paths.EntryGroup5,
  Paths.EntryGroup6,
  Paths.ReturnCheckout,
];

export const IsClaimsPage: string[] = [];

export const Routes: Record<keyof typeof Paths, Route> = {
  LandingId: {
    path: "/:id",
    element: <Landing />,
    private: true,
  },
  Landing: {
    path: Paths.Landing,
    element: <Landing />,
    private: true,
  },
  DataEntry1: {
    path: Paths.DataEntry1,
    element: <DataEntryWrapper step={0}/>,
    private: false,
  },
  DataEntry2: {
    path: Paths.DataEntry2,
    element: <DataEntryWrapper step={1}/>,
    private: false,
  },
  DataEntry3: {
    path: Paths.DataEntry3,
    element: <DataEntryWrapper step={2}/>,
    private: false,
  },
  DataEntry4: {
    path: Paths.DataEntry4,
    element: <DataEntryWrapper step={3}/>,
    private: false,
  },
  DataEntry5: {
    path: Paths.DataEntry5,
    element: <DataEntryWrapper step={4}/>,
    private: false,
  },
  EntryGroup2: {
    path: Paths.EntryGroup2,
    element: <DataEntryWrapper step={1}/>,
    private: false,
  },
  EntryGroup3: {
    path: Paths.EntryGroup3,
    element: <DataEntryWrapper step={2}/>,
    private: false,
  },
  EntryGroup4: {
    path: Paths.EntryGroup4,
    element: <DataEntryWrapper step={3}/>,
    private: false,
  },
  EntryGroup5: {
    path: Paths.EntryGroup5,
    element: <DataEntryWrapper step={4}/>,
    private: false,
  },
  EntryGroup6: {
    path: Paths.EntryGroup6,
    element: <DataEntryWrapper step={5}/>,
    private: false,
  },
  Faqs: {
    path: Paths.Faqs,
    element: <Faqs />,
    private: true,
  },
  CookiePolicy: {
    path: Paths.CookiePolicy,
    element: <CookiePolicy />,
  },
  Accessibility: {
    path: Paths.Accessibility,
    element: <Accessibility />,
    private: true,
  },
  ReturnCheckout: {
    path: Paths.ReturnCheckout,
    element: <ReturnCheckout />,
    private: true,
  },
  CheckoutResult: {
    path: Paths.CheckoutResult,
    element: <CheckoutResult />,
  },
  Error404: {
    path: Paths.Error404,
    element: <Error404 />,
  },
};
